var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "topic-header" }, [
    _c("div", { staticClass: "container" }, [
      _c("img", {
        staticClass: "photo",
        attrs: { src: _vm.src, alt: _vm.altText },
      }),
      _c("div", { staticClass: "title-background" }, [
        _c("p", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }